import React from "react";
import { getSignalMeta } from "@/lib/toneMeta";

/**
 * ToneChip
 * Pass either:
 *   - signal: a detected_signal from /api/tone/analyze (preferred), and optionally risk
 *   - tone: legacy coarse tone (anger/frustration/sarcasm/neutral/positive) — used as fallback
 *           for older persisted messages.
 */
export const ToneChip = ({ signal, risk, tone, severity, riskLabel }) => {
    const meta = getSignalMeta({ signal, risk, tone });
    return (
        <span
            data-testid="tone-chip"
            data-signal={meta.signal}
            data-risk={meta.risk}
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-[11px] font-semibold uppercase tracking-[0.08em] ${meta.chip}`}
        >
            <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
            {meta.label}
            {(riskLabel || severity) && (
                <span className="ml-1 opacity-60 font-medium normal-case tracking-normal">
                    · {riskLabel || severity}
                </span>
            )}
        </span>
    );
};

export default ToneChip;
